// LogoUpload Component
import React from "react";
import { Upload, Spin } from "antd";
import { CameraOutlined } from "@ant-design/icons";

const LogoUpload = ({
  logo,
  onImageChange,
  onLoadingChange,
  onNotification,
  isLoading,
  canUpdate,
  apiHandle,
}) => {
  const handleBeforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      onNotification("error", "Error", "You can only upload image files!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleImageChange = async (info) => {
    if (info.file.status === "uploading") {
      onLoadingChange(true);
    }

    if (info.file.status === "done") {
      try {
        const formData = new FormData();
        formData.append("file", info.file.originFileObj);

        const response = await apiHandle.post("s3-cloud-storage", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const imageUrl = response?.data?.files?.url;
        onImageChange(imageUrl);
        onNotification("success", "Success", "Image uploaded successfully!");
      } catch (error) {
        onNotification("error", "Error", "Failed to upload image");
      } finally {
        onLoadingChange(false);
      }
    }

    if (info.file.status === "error") {
      onNotification("error", "Error", "Image upload failed");
      onLoadingChange(false);
    }
  };

  return (
    <Upload
      accept="image/*"
      showUploadList={false}
      beforeUpload={handleBeforeUpload}
      onChange={handleImageChange}
      customRequest={({ file, onSuccess }) => {
        setTimeout(() => onSuccess("ok"), 0);
      }}
      disabled={!canUpdate}
    >
      <div className="relative inline-block group cursor-pointer">
        <div className="w-32 h-32 rounded-lg border-2 border-gray-200 shadow-md overflow-hidden mx-auto">
          {isLoading ? (
            <Spin
              size="large"
              className="flex items-center justify-center h-40"
            />
          ) : logo ? (
            <img
              src={logo}
              alt="Store Logo"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="flex items-center justify-center w-full h-full bg-gray-100">
              <CameraOutlined className="text-2xl text-gray-500" />
            </div>
          )}
        </div>
        <div className="absolute bottom-2 right-2 bg-white p-1 rounded-full shadow-md transform group-hover:scale-110 transition-all">
          <CameraOutlined className="text-lg text-gray-700" />
        </div>
      </div>
      <p className="text-gray-500 mt-2 text-xs">
        {logo ? "Click to change logo" : "Click to upload logo"}
      </p>
    </Upload>
  );
};

export default LogoUpload;
